//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { ObjectCustomString } from '../../models/util/object-custom-string'
import { IOpObject, IReferenceType, IOpChangeState } from '../util/interfaces'
import { OpDataList } from '../util/op-data-list'
import { OpAlarm } from '../dw/op-alarm'
import { OpAlarmEventData } from '../custom/op-alarm-event-data'
import { OpAlarmMessage } from '../dw/op-alarm-message'
import { OpAlarmType } from '../core/op-alarm-type'
import { OpDataType } from '../core/op-data-type'
import { OpDevice } from '../core/op-device'
import { OpLocation } from '../core/op-location'
import { OpMeter } from '../core/op-meter'

export class OpAlarmEvent implements IOpObject, IReferenceType, IOpChangeState {
    //Properties
    public idAlarmEvent: number
    public idAlarmDef: number
    public serialNbr: number
    public idMeter: number
    public idLocation: number
    public idAlarmType: number
    public idDataTypeAlarm: number
    public systemAlarmValue: any
    public alarmValue: any
    public time: Date
    public idIssue: number
    public isConfirmed: boolean
    public confirmedBy: number
    public confirmTime: Date
    //Properties end
    //NavigationProperties
    public location: OpLocation
    public meter: OpMeter
    public device: OpDevice
    public alarmType: OpAlarmType
    //NavigationProperties end
    //CustomProperties
    public alarmMessage: OpAlarmMessage
    public events: OpAlarm[]

    //CustomProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdAlarmEvent
    }
    public getReferenceKey(): number {
        return this.idAlarmEvent
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpAlarmEvent[]): JQueryPromise<OpAlarmEvent[]> {
        var defered = $.Deferred<OpAlarmEvent[]>()

        if (dataProvider && list && list.length > 0) {
            var idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpAlarmEvent>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpAlarmEventData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    //IOpObject implementation
    public get idObject(): any {
        return this.idAlarmEvent
    }
    public set idObject(idObject: any) {
        this.idAlarmEvent = idObject
    }

    public dataList: OpDataList<OpAlarmEventData> = new OpDataList<OpAlarmEventData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string


    public fromJSON(opObj: any, compressed: boolean = false): void {
        this.idAlarmEvent = opObj.ID_ALARM_EVENT
        this.idAlarmDef = opObj.ID_ALARM_DEF
        this.serialNbr = opObj.SERIAL_NBR
        this.idMeter = opObj.ID_METER
        this.idLocation = opObj.ID_LOCATION
        this.idAlarmType = opObj.ID_ALARM_TYPE
        this.idDataTypeAlarm = opObj.ID_DATA_TYPE_ALARM
        this.systemAlarmValue = opObj.SYSTEM_ALARM_VALUE
        this.alarmValue = opObj.ALARM_VALUE
        this.time = opObj.TIME
        this.idIssue = opObj.ID_ISSUE
        this.isConfirmed = opObj.IS_CONFIRMED
        this.confirmedBy = opObj.CONFIRMED_BY
        this.confirmTime = opObj.CONFIRM_TIME

        if (opObj.DataList)
            this.dataList.push(...opObj.DataList.map(data => new OpAlarmEventData(data)))
        else
            this.dataList = new OpDataList<OpAlarmEventData>()
        this.dynamicValues = opObj.dynamicValues
        if (opObj.AlarmMessage) {
            this.alarmMessage = new OpAlarmMessage(opObj.AlarmMessage)
        }
        if (opObj._Location) {
            this.location = new OpLocation(opObj._Location)
        }
        if (opObj._Meter) {
            this.meter = new OpMeter(opObj._Meter)
        }
        if (opObj._Device) {
            this.device = new OpDevice(opObj._Device)
        }
        if (opObj._AlarmType) {
            this.alarmType = new OpAlarmType(opObj._AlarmType)
        }

        this.opState = opObj.OpState

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_EVENT: this.idAlarmEvent,
            ID_ALARM_DEF: this.idAlarmDef,
            SERIAL_NBR: this.serialNbr,
            ID_METER: this.idMeter,
            ID_LOCATION: this.idLocation,
            ID_ALARM_TYPE: this.idAlarmType,
            ID_DATA_TYPE_ALARM: this.idDataTypeAlarm,
            SYSTEM_ALARM_VALUE: this.systemAlarmValue,
            ALARM_VALUE: this.alarmValue,
            TIME: this.time,
            ID_ISSUE: this.idIssue,
            IS_CONFIRMED: this.isConfirmed,
            CONFIRMED_BY: this.confirmedBy,
            CONFIRM_TIME: this.confirmTime,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState
        }
    }
    public toString() {
        var customFormatString = ObjectCustomString.getCustomStringFormat(this)
        if (!customFormatString) {
            if (this.alarmMessage)
                return this.alarmMessage.toString()
            if (this.location)
                return this.location.toString()
            return "AlarmEvent [" + this.idAlarmEvent + "]"
        }
        else {
            return ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
    }
    //IOpObject implementation end


}